import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CollectionQueryForm from 'Components/ComponentLibrary/Molecules/CollectionQueryForm';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import PreviousButtonPicker from 'Views/Page/Content/Templates/GeneratedViewTemplate/LeftPanel/PreviousButtonPicker';
import { metaOverrideSet } from './metaOverrideSet';

const styles = () => ({
  root: {},
  fields: {},
});

const LeftPanel = ({
  className,
  classes,
}) => {
  const { pageContentCollection, setPageContentCollection } = usePageContentContext();
  return (
    <Paper
      className={classNames(className, classes.root)}
      variant={'outlined'}
    >
      <PreviousButtonPicker />
      <CollectionQueryForm
        collection={pageContentCollection}
        metaOverrideSet={metaOverrideSet}
        onSubmit={(searchResultCollection) => {
        // Set the page context to have this as its state
          setPageContentCollection(searchResultCollection);
        }}
      />
    </Paper>
  );
};

LeftPanel.defaultProps = {
  className: '',
};

LeftPanel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LeftPanel);
